import axios from 'axios'
import { apiObject } from './apiobject'

const auth = {
  login ({ username, password }) {
    return new Promise((resolve, reject) => {
      axios.post('/api-token-auth/', { username, password }, {ignoreErrorHandle: true})
        .then(response => {
          resolve(response.data)
        }, error => {
          reject(error)
        })
    })
  },
  resetPw ({ email }) {
    return new Promise((resolve, reject) => {
      axios.post('/users/reset-password/', { email }, {ignoreErrorHandle: true})
        .then(response => {
          resolve(response.data)
        }, error => {
          reject(error)
        })
    })
  },
  magicAuth ({ email, phone, from }) {
    return new Promise((resolve, reject) => {
      axios.post('/userforms/request-token/', { email, phone, from })
        .then(response => {
          resolve(response.data)
        }, error => {
          reject(error)
        })
    })
  },
  refreshToken (token) {
    return new Promise((resolve, reject) => {
      axios.post('/api-token-refresh/', { token }, {ignoreErrorHandle: true})
        .then(response => {
          resolve(response.data)
        }, error => {
          reject(error)
        })
      })
  }
}

const currentuser = {
  url: '/users/me/',
  get () {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  save (obj) {
    return new Promise((resolve, reject) => {
      let request = axios.post(this.url, obj, {ignoreErrorHandle: true})
      request.then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  }
}

const organization = {
  url: '/users/org/',
  get () {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  save (obj) {
    return new Promise((resolve, reject) => {
      let request = axios.post(this.url, obj, {ignoreErrorHandle: true})
      request.then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  updateImage (fileUpload, type) {
    return axios.post(`${this.url}${type}/`,
      fileUpload,
      {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
      }
    )
  },
  getSupport () {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}support/`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getInfo () {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}info/`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}

export default {
  auth,
  currentuser,
  organization
}
